import React from 'react';
import Badge from '@mui/material/Badge';
import IconButton from '~/src/components/Mui/IconButton';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';

export default function App(props) {
    const badgeStyle = {
        '& .MuiBadge-badge': {
            color: '#FFFFFF',
            backgroundColor: props.business.info.custom_icon1,
        },
    };

    return (
        <IconButton aria-label="cart">
            <Badge badgeContent={props.nb} sx={badgeStyle}>
                <ShoppingBasketIcon style={{ color: props.color }} />
            </Badge>
        </IconButton>
    );
}
